import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { HomeItem, StudyToolsItem, MyCoursesItem, MyBooksItem, CareerItem, SelfItem, CreateDeckItem, ExpertFlashcardsItem, MyFlashcardsItem } from './shared/mainNavLinks.retrofit';
import { NavType } from './types';
// Function to return the signed-in navItems list based on the navType
export var getSignedInNavItems = function getSignedInNavItems(navType) {
  var userCourses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  MyCoursesItem.menuItems = userCourses && userCourses.length > 0 ? [].concat(_toConsumableArray(userCourses.map(function (_ref) {
    var courseName = _ref.courseName,
        courseDashboardUrl = _ref.courseDashboardUrl,
        courseUuid = _ref.courseUuid;
    return {
      courseUuid: courseUuid,
      text: courseName,
      href: courseDashboardUrl
    };
  })), [MyCoursesItem.menuItems[MyCoursesItem.menuItems.length - 1]]) : MyCoursesItem.menuItems; // Creating a separate HomeItem for mobile coz it have different text than desktop

  var HomeItemMobile = _objectSpread(_objectSpread({}, HomeItem), {}, {
    text: 'Chegg home'
  });

  var defaultNavItems = {
    items: [isMobile ? HomeItemMobile : HomeItem, StudyToolsItem, MyCoursesItem, MyBooksItem],
    subItems: [CareerItem, SelfItem]
  };

  switch (navType) {
    case NavType.flashcards:
      return _objectSpread(_objectSpread({}, defaultNavItems), {}, {
        subItems: [CreateDeckItem, MyFlashcardsItem, ExpertFlashcardsItem]
      });

    default:
      return defaultNavItems;
  }
};